import { render, staticRenderFns } from "./relet.vue?vue&type=template&id=36f5a15d&scoped=true&"
import script from "./relet.vue?vue&type=script&lang=js&"
export * from "./relet.vue?vue&type=script&lang=js&"
import style0 from "./relet.vue?vue&type=style&index=0&id=36f5a15d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5a15d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f5a15d')) {
      api.createRecord('36f5a15d', component.options)
    } else {
      api.reload('36f5a15d', component.options)
    }
    module.hot.accept("./relet.vue?vue&type=template&id=36f5a15d&scoped=true&", function () {
      api.rerender('36f5a15d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/relet.vue"
export default component.exports